import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const aboutApi = createApi({
  reducerPath: "aboutApi",
  baseQuery: customFetchBase({ url: "pa/about-us" }),
  endpoints: (builder) => ({
    getAbout: builder.query({
      query: ({ page = 1, search, code } = {}) => {
        let url = `?no_of_docs_each_page=25&page=${page}`;
        if (search) url += `&search=${search}`;
        if (code) url += `&code=${code}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
    updateAbout: builder.mutation({
      query: (data) => ({
        method: "PUT",
        body: data,
      }),
    }),
  }),
});
export const { useGetAboutQuery, useUpdateAboutMutation } = aboutApi;
